export function initializeOfficeMock(): Office.Context {
  const runtime = globalThis as { Office?: typeof Office };
  const defaults = {
    context: officeContextMock,
    CoercionType: { Text: 'text' },
    AsyncResultStatus: { Succeeded: 'succeeded', Failed: 'failed' },
    MailboxEnums: { RestVersion: { v2_0: 'v2.0' } },
  } as unknown as typeof Office;
  const office = (runtime.Office ??= defaults);
  office.context ??= defaults.context;
  office.CoercionType ??= defaults.CoercionType;
  office.AsyncResultStatus ??= defaults.AsyncResultStatus;
  office.MailboxEnums ??= defaults.MailboxEnums;
  office.MailboxEnums.RestVersion ??= defaults.MailboxEnums.RestVersion;
  return officeContextMock;
}

export const officeContextMock: Office.Context = {
  mailbox: {
    diagnostics: { hostName: 'OutlookWebApp', hostVersion: '' } as Office.Diagnostics,
    item: {
      itemId: 'mock-item-id',
      internetMessageId: '<mock-message-id@pinnakl.com>',
      itemType: 'message' as Office.MailboxEnums.ItemType,
      itemClass: 'IPM.Note',
      dateTimeCreated: new Date(),
      subject: 'Mock Email Subject',
      body: {
        getAsync(
          coercionType: Office.CoercionType,
          options: unknown,
          callback: (result: Office.AsyncResult<string>) => void,
        ): void {
          callback({
            value: '<p>Mock email body content</p>',
            status: Office.AsyncResultStatus.Succeeded,
          } as Office.AsyncResult<string>);
        },
      },
      sender: { displayName: 'Tom Krasner', emailAddress: 'tkrasner@concisecapital.com' },
      to: [
        { displayName: 'Yu Zhang', emailAddress: 'yzhang@sterwenbam.ch' },
        { displayName: 'Yvain Mencattini', emailAddress: 'ymencattini@bruellan.com' },
      ],
      cc: [{ displayName: 'Rohan Sharma', emailAddress: 'rsharma@pinnakl.com' }],
      bcc: [{ displayName: 'Tony Starks', emailAddress: 'tstarks@pinnakl.com' }],
      organizer: { displayName: 'Yash Pareek', emailAddress: 'ypareek@pinnakl.com' },
      requiredAttendees: [{ displayName: 'Sahil Taneja', emailAddress: 'staneja@pinnakl.com' }],
      optionalAttendees: [{ displayName: 'Rohan Sharma', emailAddress: 'rsharma@pinnakl.com' }],
      start: new Date(),
      attachments: [
        {
          id: 'mock-attachment-id',
          name: 'TestAttachment.docx',
          contentType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          size: 17098,
          attachmentType: 'file' as Office.MailboxEnums.AttachmentType,
          isInline: false,
        },
      ],
      categories: {
        addAsync(categories: string[], callback: (result: Office.AsyncResult<void>) => void): void {
          callback({ status: Office.AsyncResultStatus.Succeeded } as Office.AsyncResult<void>);
        },
      },
      addFileAttachmentFromBase64Async(
        _base64: string,
        _name: string,
        _options: Office.AsyncContextOptions & { isInline: boolean },
        callback: (result: Office.AsyncResult<string>) => void,
      ): void {
        callback({
          status: Office.AsyncResultStatus.Succeeded,
          value: crypto.randomUUID(),
        } as Office.AsyncResult<string>);
      },
      getAttachmentContentAsync(
        attachmentId: string,
        callback: (result: Office.AsyncResult<Office.AttachmentContent>) => void,
      ): void {
        callback({
          status: Office.AsyncResultStatus.Succeeded,
          value: {
            content: btoa('mock attachment content'),
            format: 'base64' as Office.MailboxEnums.AttachmentContentFormat,
          },
        } as Office.AsyncResult<Office.AttachmentContent>);
      },
    } as unknown as Office.MessageRead,
    userProfile: { displayName: 'Rohan Sharma', emailAddress: 'rsharma@pinnakl.com' } as Office.UserProfile,
    masterCategories: {
      getAsync(callback: (result: Office.AsyncResult<Office.MasterCategories>) => void): void {
        callback({
          status: Office.AsyncResultStatus.Succeeded,
          value: [{ displayName: 'Pinnakl', color: 'Preset5' }],
        } as unknown as Office.AsyncResult<Office.MasterCategories>);
      },
      addAsync(categories: Office.MasterCategories, callback: (result: Office.AsyncResult<void>) => void): void {
        callback({ status: Office.AsyncResultStatus.Succeeded } as Office.AsyncResult<void>);
      },
    } as unknown as Office.MasterCategories,
    getCallbackTokenAsync(callback: (result: Office.AsyncResult<string>) => void): void {
      callback({
        status: Office.AsyncResultStatus.Succeeded,
        value: 'mock-token',
      } as Office.AsyncResult<string>);
    },
    convertToRestId(itemId: string, _restVersion: Office.MailboxEnums.RestVersion): string {
      return itemId;
    },
  } as unknown as Office.Mailbox,
  roamingSettings: {
    get(name: string): unknown {
      const raw = sessionStorage.getItem(`office_roaming_${name}`);
      return raw ? JSON.parse(raw) : undefined;
    },
    set(name: string, value: unknown): void {
      sessionStorage.setItem(`office_roaming_${name}`, JSON.stringify(value));
    },
    remove(name: string): void {
      sessionStorage.removeItem(`office_roaming_${name}`);
    },
    saveAsync(callback: (result: Office.AsyncResult<void>) => void): void {
      callback({ status: Office.AsyncResultStatus.Succeeded } as Office.AsyncResult<void>);
    },
  } as unknown as Office.RoamingSettings,
} as Office.Context;
